var map = {
  "./shape-circle-aquamarine-gradient.png": "73427",
  "./shape-circle-aquamarine-light.png": "13602",
  "./shape-circle-aquamarine.png": "29543",
  "./shape-circle-blue-gradient.png": "88156",
  "./shape-circle-blue-light.png": "38162",
  "./shape-circle-blue.png": "69797",
  "./shape-circle-cyan-gradient.png": "75899",
  "./shape-circle-cyan-light.png": "5645",
  "./shape-circle-cyan.png": "13185",
  "./shape-circle-green-gradient.png": "5212",
  "./shape-circle-green-light.png": "73600",
  "./shape-circle-green.png": "50487",
  "./shape-circle-grey100.png": "86289",
  "./shape-circle-grey1000.png": "78075",
  "./shape-circle-grey200.png": "42511",
  "./shape-circle-grey25.png": "5275",
  "./shape-circle-grey300.png": "73556",
  "./shape-circle-grey400.png": "71681",
  "./shape-circle-grey50.png": "26961",
  "./shape-circle-grey500.png": "25278",
  "./shape-circle-grey600.png": "12560",
  "./shape-circle-grey700.png": "32057",
  "./shape-circle-grey800.png": "79545",
  "./shape-circle-grey900.png": "39074",
  "./shape-circle-indigo-gradient.png": "41135",
  "./shape-circle-indigo-light.png": "38213",
  "./shape-circle-indigo.png": "89695",
  "./shape-circle-lime-gradient.png": "48342",
  "./shape-circle-lime-light.png": "53586",
  "./shape-circle-lime.png": "80738",
  "./shape-circle-magenta-gradient.png": "7171",
  "./shape-circle-magenta-light.png": "5382",
  "./shape-circle-magenta.png": "70744",
  "./shape-circle-navy-gradient.png": "15248",
  "./shape-circle-navy-light.png": "65897",
  "./shape-circle-navy.png": "14328",
  "./shape-circle-orange-gradient.png": "93423",
  "./shape-circle-orange-light.png": "6320",
  "./shape-circle-orange.png": "87438",
  "./shape-circle-purple-gradient.png": "25681",
  "./shape-circle-purple-light.png": "27510",
  "./shape-circle-purple.png": "6484",
  "./shape-circle-red-gradient.png": "23049",
  "./shape-circle-red-light.png": "27977",
  "./shape-circle-red.png": "23403",
  "./shape-circle-yellow-gradient.png": "57179",
  "./shape-circle-yellow-light.png": "16169",
  "./shape-circle-yellow.png": "96490"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23052;
